import Api from '@/services/Api'
import GmwApi from '@/services/GmwApi'

export default {
    //GM
    getledgergm (partyname,startdate,enddate) {
        return Api().get('reports/partyledger/'+partyname+'/'+startdate+'/'+enddate)
    },

    //GMW
    getledgergmw (partyname,startdate,enddate) {
        return GmwApi().get('reports/partyledger/'+partyname+'/'+startdate+'/'+enddate)
    },
}